<style lang="scss" scoped>
.search-wrapper {
  text-align: left;
  position: relative;
  width: 100%;
  height: 42px;
  transition: 0.2s ease-out;

  &.fold {
    width: 28px;
    transition: 0.2s ease-in;
  }
}

.clear {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 32px;
  align-items: center;
  justify-content: center;
  color: var(--color-subsidary);
  cursor: pointer;

  &:hover {
    color: var(--color-neutral);
  }

  &.fold {
    display: none;
  }
}

.search-icon {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 28px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-dark);
  cursor: pointer;

  &:hover {
    color: var(--color-text);
  }
}

.search-input {
  $transition: border 0.15s ease-in-out, background 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;

  width: 100%;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px 5px 32px;
  font-size: 16px;
  margin: 5px 0px;
  background-color: transparent;
  color: var(--color-text);
  font-size: 16px;
  border: 1px solid var(--color-input);
  border-radius: 4px;
  transition: $transition, opacity 0.8s;
  outline: unset;

  &::placeholder {
    color: var(--color-neutral-light);
  }

  &:focus {
    transition: $transition, opacity 0.1s;
    border-color: var(--color-text-light);
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px var(--color-input-shadow);
    box-shadow: 0 0 0 2px var(--color-input-shadow);
  }

  &.fold {
    opacity: 0;
  }
}
</style>

<template>
  <div
    class="search-wrapper"
    :class="{fold: !isShow}"
  >
    <button
      class="search-icon"
      @click="toggleSearch()"
    >
      <Tooltip
        max-width="300"
        :delay="1000"
        placement="top"
        :content="$text.tr(isShow ? 'Свернуть' : 'поиск')"
      >
        <Icon
          type="ios-search"
          size="21"
        />
      </Tooltip>
    </button>
    <input
      ref="searchInput"
      class="search-input"
      :class="{fold: !isShow}"
      :placeholder="$text.tr('поиск')"
      v-model="search"
      :disabled="!isShow"
      @keydown.esc="clearOrExit()"
    />
    <button
      class="clear"
      :class="{fold: !isShow}"
      @click="clearOrExit()"
      :title="$text.tr(search.trim().length ? '' : 'Свернуть')"
    >
      <Icon
        type="ios-close-circle"
        size="16"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    isShowSearch: Boolean
  },
  computed: {
    search: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    isShow: {
      get () {
        return this.isShowSearch
      },
      set (val) {
        this.$emit('update:isShowSearch', val)
      }
    }
  },
  watch: {
    isShow: function (value) {
      if (value) {
        this.focusSearchInput()
      } else {
        this.search = ''
      }
    }
  },
  methods: {
    clearOrExit () {
      if (this.search.trim().length) {
        this.clear()
      } else {
        this.isShow = false
      }
    },
    clear () {
      this.search = ''
      this.focusSearchInput()
    },
    focusSearchInput () {
      setTimeout(() => {
        this.$refs.searchInput.focus()
      }, 300)
    },
    toggleSearch () {
      this.isShow = !this.isShow
    }
  }
}
</script>
